import { BettingOfferKeyUpdate, PageableOfferResponse } from "@gp/models";

export function convertApiOfferResponseToHubModel(
	offerResponse: PageableOfferResponse
) {
	if (!offerResponse.offer) {
		return offerResponse;
	}

	const offerUpdates = offerResponse.offer.map((item) => {
		let newOffer = {};
		let offers: BettingOfferKeyUpdate[] = [];
		if (item.offers != null) {
			offers = item.offers.map((i) => {
				return {
					bettingTypeId: i.bettingTypeId,
					key: i.key,
					keyId: i.keyId,
					offers: {
						updates: i.offers ? [...i.offers] : [],
					},
				};
			});
		}
		newOffer = {
			event: {
				...item.event,
			},
			eventId: item.eventId,
			offers: {
				updates: [...offers],
			},
		};
		return newOffer;
	});

	const response = {
		lookups: {
			...offerResponse.lookup,
		},
		offerChanges: {
			updates: [...offerUpdates],
		},
	};

	return response;
}
